<template>
	<div class="header_container">
		<nav class="nav container">
			<div class="nav-box">
				<a href="/" class="nav-logo">
					<img src="../../assets/img/index/康和达.png" alt="上海康和达" class="logo" />
				</a>
				<div class="nav-toggle" id="nav_toggle">
					<i class="bx bx-menu menu"></i>
					<i class="bx bx-x close"></i>
				</div>
			</div>
			<div class="nav-menu" id="nav_menu">
				<ul class="nav-list">
					<li><a href="/" class="nav-link">网站首页</a></li>
					<li><a href="/ProductCenter" class="nav-link">产品中心</a></li>
					<li class="dropdown-item" id="dropdown_item">
						<div class="nav-link" id="sub_title">
							产品详情<i class='bx bxs-chevron-right right'></i>
						</div>
						<ul class="dropdown-menu" id="dropdown_menu">
							<li>
								<a href="/MixedCells" class="dropdown-link">Mixed Cells 病毒分离培养混合细胞</a>
							</li>
							<li>
								<a href="/CellogerMiniPlus" class="dropdown-link">Celloger Mini Plus 全自动活细胞成像分析系统</a>
							</li>
							<li>
								<a href="/CellogerPro" class="dropdown-link">Celloger Pro 全自动活细胞成像分析系统</a>
							</li>
							<li>
								<a href="/CellogerNano" class="dropdown-link">Celloger Nano 活细胞影像仪</a>
							</li>
							<li>
								<a href="/CellogerStack" class="dropdown-link">Celloger Stack 全自动细胞工厂成像仪</a>
							</li>
							<li>
								<a href="/FacscopeB" class="dropdown-link">FACSCOPE B 自动细胞计数仪</a>
							</li>
							<li>
								<a href="/Slide" class="dropdown-link">FACSCOPE 一次性计数板</a>
							</li>
							<li>
								<a href="/Cellpuri" class="dropdown-link">Cellpuri 一次性细胞富集芯片</a>
							</li>
						</ul>
					</li>
					<li><a href="/Reference" class="nav-link">引用文献</a></li>
					<li><a href="/ContactUs" class="nav-link">联系我们</a></li>
				</ul>
			</div>
			<div class="tel">
				<TrialButton class="wb"></TrialButton>
				<div class="num">181-1812-8515</div>
			</div>
		</nav>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import TrialButton from './TrialButton.vue';
	export default {
		name: 'Header',
		components: {
			TrialButton
		},
		computed: mapState(['headerShadowActive', 'headerShow', 'headerLogoShow', 'navDarkActive']),
		methods: {
			/*=============== SHOW MENU ===============*/
			showMenu() {
				const toggle = document.getElementById('nav_toggle');
				const nav = document.getElementById('nav_menu')

				toggle.addEventListener('click', () => {
					nav.classList.toggle('show-menu')
					toggle.classList.toggle('show-icon')
				})

				const subtitle = document.getElementById('sub_title');
				const dropdown = document.getElementById('dropdown_menu');

				subtitle.addEventListener('click', () => {
					dropdown.classList.toggle('show-submenu')
					subtitle.classList.toggle('show-subicon')
				})
			},
		},
		mounted() {
			this.showMenu();
		}
	}
</script>

<style scoped>
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	.header_container .logo {
		flex: 0 0 auto;
		margin-top: 10px;
	}

	.header_container .logo img {
		height: 80px;
		width: 200px;
	}

	.tel {
		display: flex;
		align-items: center;
	}

	.num {
		margin-left: 20px;
		cursor: pointer;
	}

	.header_container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		background-color: white;
		box-shadow: 0 2px 16px hsla(220, 32%, 8%, 0.3);
	}

	ul {
		list-style: none;
	}

	a {
		text-decoration: none;
	}

	.logo {
		width: 180px;
	}

	.nav-box {
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.logo {
		display: inline-flex;
		align-items: center;
		column-gap: .25rem;
	}

	@media screen and (max-width: 1150px) {
		.header_container {
			position: relative !important;
		}
		
		.container {
			max-width: 1000px;
			margin-inline: 1.5rem;
		}
		
		.nav-toggle {
			position: relative;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}

		.menu,
		.close {
			color: black;
			position: absolute;
			width: max-content;
			height: max-content;
			inset: 0;
			margin: auto;
			font-size: 1.25rem;
			cursor: pointer;
			transition: opacity .1s, transform .4s;
		}

		.close {
			opacity: 0;
		}

		.nav-menu {
			width: 100%;
			position: absolute;
			left: 0;
			background-color: #ffffffe6;
			opacity: 0;
			pointer-events: none;
			transition: top .3s, opacity .3s;
		}

		.nav-menu::-webkit-scrollbar {
			width: 0;
		}
		
		.nav-list{
			box-shadow: 0 5px 10px hsla(220, 32%, 8%, 0.3);
		}

		.nav-link {
			color: black;
			padding: 1.1rem 1.5rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 16px;
			transition: background-color .3s;
			cursor: pointer;
		}

		.nav-link:hover {
			background-color: rgba(255, 240, 0, 0.8);
		}

		.show-menu {
			opacity: 1;
			pointer-events: initial;
		}

		.show-icon .menu {
			opacity: 0;
			transform: rotate(90deg);
		}

		.show-icon .close {
			opacity: 1;
			transform: rotate(90deg);
		}

		.dropdown-menu {
			left: 0;
			max-height: 0;
			overflow: hidden;
			transition: max-height .4s ease-out;
		}

		.dropdown-link {
			color: black;
			padding: 1.1rem 1.5rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 16px;
			transition: background-color .3s;
			cursor: pointer;
		}

		.dropdown-link:hover {
			background-color: rgba(255, 240, 0, 0.8);
		}

		.dropdown-menu.show-submenu {
			max-height: 500px;
			pointer-events: initial;
		}

		.right {
			transition: transform 0.3s ease;
		}

		.show-subicon .right {
			transform: rotate(90deg);
		}

		.tel {
			display: none;
		}
	}

	@media screen and (min-width: 1150px) {
		.container {
			margin-inline: auto;
		}

		.nav {
			height: 5rem;
			display: flex;
			justify-content: space-around
		}

		.nav-toggle {
			display: none;
		}

		.nav-menu {
			background-color: white;
			transition: top .5s, opacity .5s;
		}

		.nav-list {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			column-gap: 3rem;
		}

		.nav-link {
			color: black;
			padding: 1.5rem 1.5rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 19px;
			transition: background-color .3s;
			cursor: pointer;
			column-gap: .25rem;
		}

		.nav-link:hover {
			background-color: rgba(255, 240, 0, 0.8);
		}

		.dropdown-link:hover {
			background-color: rgba(255, 240, 0, 0.8);
			border-radius: 5px;
		}

		.dropdown-item {
			position: relative;
		}

		.right {
			margin-top: 2.5px;
			transition: transform 0.3s ease;
		}

		.dropdown-menu {
			width: 23rem;
			max-height: initial;
			overflow: initial;
			position: absolute;
			background-color: #ffffffe6;
			left: 0;
			top: 3.2rem;
			opacity: 0;
			pointer-events: none;
			transition: opacity .2s, top .3s;
			border-radius: 5px;
		}

		.dropdown-item:hover .right {
			transform: rotate(90deg);
		}

		.dropdown-link {
			color: black;
			padding: 0.75rem 1rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 16px;
			transition: background-color .3s;
			cursor: pointer;
		}

		.dropdown-item:hover .dropdown-menu {
			opacity: 1;
			top: 4.2rem;
			pointer-events: initial;
			transition: top .3s;
		}
	}
	@media screen and (max-width: 1265px) {
		.num{
			display: none;
		}
		
	}
</style>